import userAction from '@sh/mixins/userAction';
import notifications from '@sh/mixins/notifications';
import config from '../views/Campaign/config';

export default {
  mixins: [notifications, userAction],
  data() {
    return {
      rules: {
        campaignsMap: {},
      },
      maxCpcLimit: 0.5,
    };
  },
  methods: {
    async $_updateStatus(item, value) {
      try {
        const action = value ? 'start' : 'pause';
        const result = await this.$api.campaigns.action(item.campaign_id, action);
        item.enabled = result.enabled;
        item.status = result.status;
        item.traffic_source_status = result.traffic_source_status;
        this.$n_successNotification({ title: result.message || 'Status successfully updated' });
      } catch (error) {
        try {
          this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
        } catch (err) {
          this.$n_failNotification({ title: 'An error occurred' });
        }
      }
    },
    async $_updateBid(item, value, type) {
      const task = this.userAction.task.create();
      try {
        type = type !== 'unsupported' ? type : null;
        if (config.bidTypeOptions[item.traffic_source_unique_name]) {
          await this.$api.campaigns.changeCampaignBid(item.campaign_id, value, type);
        } else {
          await this.$api.campaigns.changeCampaignBid(item.campaign_id, value);
        }
        this.$n_successNotification({ title: 'Bid successfully updated' });
        task.finish();
        return true;
      } catch (error) {
        try {
          this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
        } catch (err) {
          this.$n_failNotification({ title: 'An error occurred' });
        }
      }
      task.finish();
      return false;
    },
    async $_updateBudget(item, value, type = 'limited') {
      const task = this.userAction.task.create();
      try {
        const budgetType = value ? 'limited' : type;
        const response = await this.$api.campaigns.changeCampaignTotalBudget(item.campaign_id, value, budgetType);
        if (response.message) {
          item.budget = value;
          item.budget_type = budgetType;
        }
        this.$n_successNotification({ title: response.message || 'Budget successfully updated' });
        task.finish();
        return true;
      } catch (error) {
        try {
          this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
        } catch (err) {
          this.$n_failNotification({ title: 'An error occurred' });
        }
      }
      task.finish();
      return false;
    },
    async $_updateDailyBudget(item, value, type = 'limited') {
      const task = this.userAction.task.create();
      try {
        const dailyBudgetType = value ? 'limited' : type;
        const response = await this.$api.campaigns.changeCampaignDailyBudget(item.campaign_id, value, dailyBudgetType);
        if (response.message) {
          item.daily_budget = value;
          item.daily_budget_type = dailyBudgetType;
        }
        this.$n_successNotification({ title: response.message || 'Daily Budget successfully updated' });
        task.finish();
        return true;
      } catch (error) {
        if (item.traffic_source_unique_name === 'BidVertiser') {
          this.$n_failNotification({ title: 'Budget too low' });
        } else {
          this.$n_failNotification({ title: 'An error occurred' });
        }
      }
      task.finish();
      return false;
    },
    async $_apiRules() {
      try {
        const result = await this.$api.rules.index();
        result.forEach((rule) => {
          rule.campaign_ids.forEach((id) => {
            if (!this.rules.campaignsMap[id]) this.rules.campaignsMap[id] = [];
            this.rules.campaignsMap[id].push({
              rule_action: rule.rule_action,
              name: rule.name,
              _id: rule._id,
            });
          });
        });
      } catch (error) {
        try {
          this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
        } catch (err) {
          this.$n_failNotification({ title: 'An error occurred' });
        }
      }
    },
    $_smartMaxCpcMaxLimit(avgCpc, cpc) {
      return () => {
        if (avgCpc) {
          return parseFloat(2 * parseFloat(avgCpc));
        } if (cpc) {
          return parseFloat(2 * parseFloat(cpc));
        }
        return this.maxCpcLimit;
      };
    },
  },
};
